import { useSafeAreaInsets } from 'react-native-safe-area-context';

export interface SafeAreaTokens {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

/**
 * Thin wrapper over `useSafeAreaInsets` that returns numeric insets in a
 * stable shape — bottom-anchored surfaces (toast viewport, sheets, sticky
 * action bars) consume it without coupling to the underlying library. On
 * web, the safe-area-context stub returns zero insets, so this hook is
 * cheap to call even from cross-platform components.
 */
export function useSafeAreaTokens(): SafeAreaTokens {
  const insets = useSafeAreaInsets();
  return {
    top: insets.top,
    right: insets.right,
    bottom: insets.bottom,
    left: insets.left,
  };
}
